var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/modal/request-swatch-confirmation-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/form-validation.j2", false, "product/templates/modal/request-swatch-confirmation-form.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n\n<div class=\"dom-request-swatch-form\" data-qa-request-swatch-confirmation>\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12\">\n            <h1 class=\"c-request-swatch__h1\">\n                ";
output += runtime.suppressValue((lineno = 8, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-success-heading"])), env.opts.autoescape);
output += "\n            </h1>\n            <p class=\"c-request-swatch__p\">\n                ";
output += runtime.suppressValue((lineno = 11, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-page3-block1"])), env.opts.autoescape);
output += "\n            </p>\n            <p class=\"c-request-swatch__p c-request-swatch__p--confirmed\">\n                ";
output += runtime.suppressValue((lineno = 14, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-page3-block2"])), env.opts.autoescape);
output += "\n            </p>\n            <h2 class=\"c-request-swatch__h2\">\n                ";
output += runtime.suppressValue((lineno = 17, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-modal-page3-subtitle"])), env.opts.autoescape);
output += "\n            </h2>\n            <h3 class=\"c-request-swatch__h4\" data-qa-request-swatch-count=";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectedCount"), env.opts.autoescape);
output += ">\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectedCount"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 20, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-swatches-requested"])), env.opts.autoescape);
output += " <span class=\"c-request-swatch__h3\" data-qa-request-swatch-product-name>(";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectedProduct")),"displayName"), env.opts.autoescape);
output += ")</span>\n            </h3>\n        </div>\n    </div>\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12 u-no-gutters\">\n            <ul>\n            ";
frame = frame.push();
var t_10 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRequestSwatch")),"selectedSwatches");
if(t_10) {var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("swatch", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\n                <li class=\"c-request-swatch-selection-outer o-column o-extra-small--6 o-small--4 o-medium--3 o-large--2\">\n                    <div class=\"c-request-swatch-selection-inner c-request-swatch-selection-inner--confirmed\">\n                        <img class=\"c-request-swatch__swatch\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_11),"url"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_11),"displayName"), env.opts.autoescape);
output += "\" data-qa-request-swatch-confirmed-image/>\n                        <div class=\"c-request-swatch-selection__name\" data-qa-request-swatch-confirmed-choice=\"";
output += runtime.suppressValue(runtime.memberLookup((t_11),"colorCode"), env.opts.autoescape);
output += "\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((t_11),"displayName"), env.opts.autoescape);
output += "\n                        </div>\n                    </div>\n                </li>\n            ";
;
}
}
frame = frame.pop();
output += "\n            </ul>\n        </div>\n    </div>\n\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12 o-medium--8 o-large--6 o-extra-small--centered\">\n            <button class=\"c-button-primary c-request-swatch__button c-request-swatch__button--continue js-request-swatch-continue\" type=\"submit\" data-qa-request-swatch-continue>\n                ";
output += runtime.suppressValue((lineno = 44, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_request-swatch-continue-shopping"])), env.opts.autoescape);
output += "\n            </button>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/modal/request-swatch-confirmation-form.j2"] , dependencies)